import {
  FormFieldBlueprint,
  createFormField,
} from '@backstage/plugin-scaffolder-react/alpha';
import { ParticipationAgreementField } from './ParticipationAgreementField';

export const ParticipationAgreementFieldExtension = FormFieldBlueprint.make({
  name: 'participation-agreement-field',
  params: {
    field: async () =>
      createFormField({
        name: 'ParticipationAgreementField',
        component: ParticipationAgreementField,
        validation: (value, validation) => {
          if (!value) {
            validation.addError(
              'You must agree to the participation agreement before continuing.',
            );
          }
        },
      }),
  },
});
